export const DELETE_DEPARTMENT = 'DELETE_DEPARTMENT';
export const REFRESH_DEPARTMENTS = 'REFRESH_DEPARTMENTS';
export const UPDATE_DEPARTMENT = 'UPDATE_DEPARTMENT';
export const ADD_DEPARTMENT = 'ADD_DEPARTMENT';